import { handleActions } from 'redux-actions';
import { UPDATE_ACHIEVEMENT } from '../actionTypes';
import { achievementMes } from '../initialState';

export default handleActions(
  {
    [UPDATE_ACHIEVEMENT]: (state, action) => {
      // return action.payload;
      return {
        ...state,
        user: action.payload.user,
        level: action.payload.level
      };
    }
  },
  achievementMes
);
